export default {
  //Database
  databaseList: [],
  databaseSelectedVersion: "",
  databaseSelectedItem: null,
  databaseLoading: false,
  databaseErrorMessages: "",
  //Ready Application
  readyAppsList: [],
  readyAppsSelectedVersion: "",
  readyAppsSelectedItem: null,
  readyAppsLoading: false,
  readyAppsErrorMessages: [],
  //Custom Application
  customAppsList: [],
  customAppsSelectedVersion: "",
  customAppsSelectedItem: null,
  customAppsLoading: false,
  customAppsErrorMessages: "",
  // Common Service
  userDbList: [],
  userDbSelected: null,
  serviceName: { value: "", error: "" },
  validServiceName: null,
  typeService: ""
};
